import React from "react";
import "./Legal.css";

export default function UserTermsOfService() {
  return (
    <div className="legal-page-container">
      <h1>Koala Quest Terms of Service</h1>
      <p><strong>Last Updated:</strong> [Insert Date]</p>

      <h2>1. Account Creation</h2>
      <p>Children under 13 must sign up with the help of a parent or guardian. Parents may sign up via email, Google, or Facebook. You are responsible for maintaining the security of your login credentials.</p>

      <h2>2. Educational Use</h2>
      <p>All content provided on Koala Quest is for educational and non-commercial purposes only. Reproduction or redistribution is prohibited without permission.</p>

      <h2>3. Data Use</h2>
      <p>We collect data related to account login, usage, learning progress, and performance.
        For parent accounts, certain information (such as email) may be used for analytics and advertising optimization via third-party services (Google Analytics, Meta/Facebook Pixel), but only with your consent and never for marketing to children.
        Please refer to our Privacy Policy for full details.</p>

      <h2>4. Community Rules</h2>
      <ul>
        <li>No inappropriate content (violence, hate, explicit language).</li>
        <li>Do not share personal information (phone number, address) via chat.</li>
        <li>Violations may result in suspension or termination of your account.</li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>All content and visuals on Koala Quest are owned by Koala Quest or licensed partners. Unauthorized use is prohibited.</p>

      <h2>6. Service Availability</h2>
      <p>We strive for uninterrupted access but cannot guarantee uptime. We reserve the right to modify or discontinue the service at any time.</p>

      <h2>7. Termination and Data Deletion</h2>
      <p>Parents can request data deletion by contacting us. Inactive accounts for 12+ months may be purged from the system.</p>

      <h2>8. Governing Law</h2>
      <p>This agreement is governed by the laws of British Columbia, Canada.</p>

      <h2>9. Contact</h2>
      <p>Koala Quest Canada<br />Email: <a href="mailto:koalaquestcanada@gmail.com">koalaquestcanada@gmail.com</a><br />Website: <a href="https://koalaquest.ca">https://koalaquest.ca</a></p>
    </div>
  );
}
